const videoUrlRegExes = {
    youtubeUrl: /(http|https):\/\/(www\.youtube\.com\/watch\?v=|youtu\.be\/)([A-Za-z0-9~_%-]*)?/,
    youtubeEmbed: /(http|https):\/\/(www\.youtube\.com)\/(embed\/)([A-Za-z0-9~_%-]*)?/,
    vimeoUrl: /(http|https):\/\/(vimeo\.com)\/([A-Za-z0-9~_%-]*)?/,
    vimeoEmbed: /(http|https):\/\/(player\.vimeo\.com)\/(video\/)([A-Za-z0-9~_%-]*)?/
};

const normalizeVideoUrl = (url) => {
    // Checking if the url actually matches any of these regexes
    let regex = '';
    Object.values(videoUrlRegExes).forEach((source) => {
        if (source.test(url)) {
            regex = source;
        }
    });
    if (regex) {
        const matched = url.match(regex);
        const vidId = matched.pop(); // Always the last part of the regex
        if (url.indexOf('youtube.com') > -1 || url.indexOf('youtu.be') > -1) {
            return `https://www.youtube.com/embed/${vidId}`;
        }
        if (url.indexOf('vimeo.com') > -1) {
            return `https://player.vimeo.com/video/${vidId}`;
        }
    }
    return null;
};

export default normalizeVideoUrl;
